import {
  ClientContext,
  ClientSideSuspense,
  CreateThreadError,
  LiveblocksProvider,
  PKG_FORMAT,
  PKG_NAME,
  PKG_VERSION,
  RoomContext,
  _RoomProvider,
  _useAddReaction,
  _useBroadcastEvent,
  _useCreateThread,
  _useDeleteThread,
  _useEditThreadMetadata,
  _useEventListener,
  _useHistoryVersions,
  _useInboxNotificationThread,
  _useIsInsideRoom,
  _useMutation,
  _useMyPresence,
  _useOther,
  _useOthers,
  _useOthersListener,
  _useOthersMapped,
  _useRoom,
  _useSelf,
  _useStorage,
  _useStorageRoot,
  _useThreads,
  _useUpdateMyPresence,
  _useUser,
  _useUserThreads_experimental,
  createLiveblocksContext,
  createRoomContext,
  getUmbrellaStoreForClient,
  selectThreads,
  useAttachmentUrl,
  useBatch,
  useCanRedo,
  useCanUndo,
  useClient,
  useCommentsErrorListener,
  useCreateComment,
  useDeleteAllInboxNotifications,
  useDeleteComment,
  useDeleteInboxNotification,
  useEditComment,
  useErrorListener,
  useHistory,
  useHistoryVersionData,
  useInboxNotifications,
  useLostConnectionListener,
  useMarkAllInboxNotificationsAsRead,
  useMarkInboxNotificationAsRead,
  useMarkThreadAsRead,
  useMarkThreadAsResolved,
  useMarkThreadAsUnresolved,
  useOthersConnectionIds,
  useRedo,
  useRemoveReaction,
  useRoomInfo,
  useRoomNotificationSettings,
  useStatus,
  useStorageStatus,
  useThreadSubscription,
  useUndo,
  useUnreadInboxNotificationsCount,
  useUpdateRoomNotificationSettings
} from "./chunk-OFQLSRKM.mjs";

// src/index.ts
import { detectDupes } from "@liveblocks/core";
import { shallow } from "@liveblocks/client";
detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);
export {
  ClientContext,
  ClientSideSuspense,
  CreateThreadError,
  LiveblocksProvider,
  RoomContext,
  _RoomProvider as RoomProvider,
  createLiveblocksContext,
  createRoomContext,
  getUmbrellaStoreForClient,
  selectThreads,
  shallow,
  _useAddReaction as useAddReaction,
  useAttachmentUrl,
  useBatch,
  _useBroadcastEvent as useBroadcastEvent,
  useCanRedo,
  useCanUndo,
  useClient,
  useCommentsErrorListener,
  useCreateComment,
  _useCreateThread as useCreateThread,
  useDeleteAllInboxNotifications,
  useDeleteComment,
  useDeleteInboxNotification,
  _useDeleteThread as useDeleteThread,
  useEditComment,
  _useEditThreadMetadata as useEditThreadMetadata,
  useErrorListener,
  _useEventListener as useEventListener,
  useHistory,
  useHistoryVersionData,
  _useHistoryVersions as useHistoryVersions,
  _useInboxNotificationThread as useInboxNotificationThread,
  useInboxNotifications,
  _useIsInsideRoom as useIsInsideRoom,
  useLostConnectionListener,
  useMarkAllInboxNotificationsAsRead,
  useMarkInboxNotificationAsRead,
  useMarkThreadAsRead,
  useMarkThreadAsResolved,
  useMarkThreadAsUnresolved,
  _useMutation as useMutation,
  _useMyPresence as useMyPresence,
  _useOther as useOther,
  _useOthers as useOthers,
  useOthersConnectionIds,
  _useOthersListener as useOthersListener,
  _useOthersMapped as useOthersMapped,
  useRedo,
  useRemoveReaction,
  _useRoom as useRoom,
  useRoomInfo,
  useRoomNotificationSettings,
  _useSelf as useSelf,
  useStatus,
  _useStorage as useStorage,
  _useStorageRoot as useStorageRoot,
  useStorageStatus,
  useThreadSubscription,
  _useThreads as useThreads,
  useUndo,
  useUnreadInboxNotificationsCount,
  _useUpdateMyPresence as useUpdateMyPresence,
  useUpdateRoomNotificationSettings,
  _useUser as useUser,
  _useUserThreads_experimental as useUserThreads_experimental
};
//# sourceMappingURL=index.mjs.map